interface Strings {
  locationAssistiveLabel?: string,
}

export class CartSlotConfig {
  public static defaultStrings: Strings = {}
}
